module.exports = __webpack_public_path__ + "static/media/404.634231ac.svg";